
import Vue from "vue";
import TheTemplate from "../TheTemplate.vue";

export default Vue.extend({
  name: "instructions",
  components: {
    TheTemplate,
  },
  computed: {},
  methods: {},
});
